const CDN_DEV_URL = 'https://cdn-dev.public.zooplus.net';
const CDN_PROD_URL = 'https://cdn.public.zooplus.net';
const PRIVATE_ZOOPLUS_NET = 'private.zooplus.net';

export { CDN_DEV_URL, CDN_PROD_URL, PRIVATE_ZOOPLUS_NET };
//# sourceMappingURL=types.js.map
